import React, { useEffect } from 'react';
import { Toast } from 'flowbite-react';
import { hideToast } from '../../slices/toastSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';

const ToastMessage = () => {
  const { message, isShow } = useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();
  const toastClass = isShow ? 'block' : 'hidden';

  useEffect(() => {
    if (isShow) {
      setTimeout(() => {
        dispatch(hideToast());
      }, 2000);
    }
  }, [isShow]);

  return (
    <Toast className={`${toastClass} absolute left-1/2 top-0 -translate-x-1/2`}>
      <div data-testid="toast-message" className="pl-4 text-sm font-normal">
        {message}
      </div>
    </Toast>
  );
};

export default ToastMessage;
